import { Action } from "redux";

export const WFS_3D_LAYER_LOADING = "WFS_3D_LAYER_LOADING";

export const wfs3dLayerLoadingAction = (): Action => {
    return {
        type: WFS_3D_LAYER_LOADING,
    };
};
